/**
 * Agrupa las órdenes por día de servicio (spec 012).
 *
 * Una mesa cerrada de madrugada (antes de las 06:00) cuenta en el día
 * anterior, que es cuando empezó la cena. Todo en hora local del navegador.
 */

export interface ServiceDay<T> {
  key: string;
  date: Date;
  /** «24/10/2026» */
  label: string;
  orders: T[];
}

/** Hora a la que empieza un día de servicio nuevo */
export const SERVICE_DAY_START_HOUR = 6;

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

export function formatTime(date: Date): string {
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function formatDate(date: Date): string {
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}

function serviceDate(time: Date): Date {
  const offset = time.getHours() < SERVICE_DAY_START_HOUR ? 1 : 0;
  return new Date(time.getFullYear(), time.getMonth(), time.getDate() - offset);
}

export function groupOrdersByServiceDay<T extends { created_at: string }>(orders: T[]): ServiceDay<T>[] {
  const days = new Map<string, ServiceDay<T>>();

  for (const order of orders) {
    const time = new Date(order.created_at);
    if (Number.isNaN(time.getTime())) continue;
    const date = serviceDate(time);
    const key = formatDate(date);
    const day = days.get(key) ?? { key, date, label: key, orders: [] };
    day.orders.push(order);
    days.set(key, day);
  }

  const byTimeDesc = (a: T, b: T) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  return [...days.values()]
    .sort((a, b) => b.date.getTime() - a.date.getTime())
    .map((day) => ({ ...day, orders: day.orders.sort(byTimeDesc) }));
}
